import type { JSX } from 'preact';
import sideViewSource from '../../../assets/svg/boat_side_view.svg?raw';
import { renderSideViewSvg, type BoatDocument } from '../../sim/boat/index.ts';

/** Side view with this boat's colours and fittings. Callers size it in CSS. */
export function BoatSideArt({
  boat,
  className = 'boat-side-portrait',
}: {
  boat: Pick<BoatDocument, 'lengthM' | 'draftM' | 'side' | 'fittings'>;
  className?: string;
}): JSX.Element {
  return (
    <div
      class={className}
      aria-hidden="true"
      dangerouslySetInnerHTML={{
        __html: renderSideViewSvg(sideViewSource, boat),
      }}
    />
  );
}
